<template>
  <div>
    <template slot="header">
      <div class="display-5">
        <i class="fa fa-print"></i> Agregar Nuevo Tag
      </div>
    </template>
    <b-container>
      <b-card-group >
        <b-card header-tag="header" footer-tag="footer">
          <template v-slot:header>
            <h6 class="mb-0">Tag 1</h6>
          </template>
            <b-table
              :busy="isBusy"
              striped
              bordered
              hover
              small
              footClone
              :items="listatag1"
              :fields="fields"
              sticky-header
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template slot="acciones" slot-scope="row">
                <b-button
                  size="sm"
                  variant="ligth"
                  v-b-tooltip.hover
                  title="Editar Tag"
                  @click="modal(3, row.item)"
                >
                  <i class="far fa-edit text-primary"></i>
                </b-button>
                <b-button
                  variant="ligth"
                  size="sm"
                  v-b-tooltip.hover
                  title="Eliminar Tag"
                  @click="deleteTag(row.item)"
                >
                  <i class="far fa-trash-alt text-danger"></i>
                </b-button>
              </template>
            </b-table>
          <template v-slot:footer>
            <div class="text-right">
              <!-- <b-button  class="mr-2" variant="info" @click="listTag()">Refrescar</b-button> -->
              <b-button variant="success" @click="modal(1)">Agregar Tag</b-button>
            </div>
          </template>
        </b-card>

        <b-card header-tag="header" footer-tag="footer">
          <template v-slot:header>
            <h6 class="mb-0">Tag 2</h6>
          </template>
            <b-table
              :busy="isBusy"
              striped
              bordered
              hover
              small
              footClone
              noCollapse
              :items="listatag2"
              :fields="fields"
              sticky-header
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template slot="acciones" slot-scope="row">
                <b-button
                  size="sm"
                  variant="ligth"
                  v-b-tooltip.hover
                  title="Editar Tag"
                  @click="modal(4, row.item)"
                  class="mr-1"
                >
                  <i class="far fa-edit text-primary"></i>
                </b-button>
                <b-button
                  variant="ligth"
                  size="sm"
                  v-b-tooltip.hover
                  title="Eliminar Tag"
                  @click="deleteTag(row.item)"
                >
                  <i class="far fa-trash-alt text-danger"></i>
                </b-button>
              </template>
            </b-table>
            <!-- <b-pagination
          v-model="currentPage"
          :total-rows="total"
          :per-page="perPage"
          @input="listTag()"
            ></b-pagination>-->
          <template v-slot:footer>
            <div class="text-right">
               <!-- <b-button  class="mr-2" variant="info" @click="listTag()">Refrescar</b-button> -->
              <b-button variant="success" @click="modal(2)">Agregar Tag</b-button>
            </div>
          </template>
        </b-card>
<!--Agregar categoria INICIO-->
        <b-card>
             <template v-slot:header>
            <h6 class="mb-0">Agregar Categoria Producto</h6>
            </template>

            <b-table 
                    small
                    :items="listaCategoria"
                    :fields="listaCategoria_fields"
                    head-variant="dark"
                    bordered
                    sticky-header
                  >
                  <template slot="index" slot-scope="row">{{row.index +1}}</template>
                  <template slot="acciones" slot-scope="row">  
                      <template v-if="row.item.idCategoria == 33"></template> 
                      <template v-else>
                        <b-button v-b-modal.categorias variant="ligth" size="sm" @click.prevent="toUpdateCategoria(row.item.descripcion, row.item.idCategoria)">
                         <i class="far fa-edit text-primary"></i>
                        </b-button>
                        <b-button variant="ligth" size="sm" @click.prevent="deleteCategoria(row.item.idCategoria)">
                          <i class="far fa-trash-alt text-danger"></i>
                      </b-button>
                      </template>                                              
                  </template>
              </b-table>

            <template v-slot:footer>
            <div class="text-right">  
              <b-button v-b-modal.categorias variant="success" >
                  Categoría Producto
                  <i class="fa fa-plus"></i> 
              </b-button>
            </div>
          </template>

          <b-modal id="categorias" title="Categorías Producto">
               <vue-snotify></vue-snotify>
                  <template>
                    <b-row>
                      <template v-if="!mostraredit">
                        <b-col cols="12" sm="5" md="5" lg="4" xl="2">
                        <b-button variant="success" class="mb-3" @click="addCategoria()" >
                                <i class="fa fa-plus"></i> 
                        </b-button>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="10">
                            <b-form-input v-model="descripcionCat"  @input="descripcionCat = descripcionCat.toUpperCase()" placeholder="Categoría"></b-form-input>
                        </b-col>
                      </template>
                    <template v-else-if="mostraredit">        
                      <b-col cols="12" sm="5" md="5" lg="4" xl="2" >
                          <b-button variant="primary" @click="actualizarCategoria()">
                              Editar
                          </b-button>
                      </b-col>
                       <b-col cols="12" sm="5" md="5" lg="4" xl="10"  class="mb-3">
                          <b-form-input v-model="editCat"></b-form-input>
                      </b-col>
                  </template>
                  </b-row>                                                                                
                  <b-table 
                    small
                    responsive
                    :items="listaCategoria"
                    :fields="listaCategoria_fields"
                    head-variant="dark"
                    bordered
                    sticky-header
                  >
                  <template slot="index" slot-scope="row">{{row.index +1}}</template>
                  <template slot="acciones" slot-scope="row">                 
                      <template v-if="row.item.idCategoria == 33"></template>  
                      <template v-else>     
                        <b-button variant="ligth" size="sm" @click.prevent="toUpdateCategoria(row.item.descripcion, row.item.idCategoria)">
                            <i class="far fa-edit text-primary"></i>
                        </b-button>                                         
                        <b-button variant="ligth" size="sm" @click.prevent="deleteCategoria(row.item.idCategoria)">
                            <i class="far fa-trash-alt text-danger"></i>
                        </b-button>  
                      </template>                                            
                  </template>
                  </b-table>
              </template>
          </b-modal>
        </b-card>
<!--Agregar categoria FIN-->
<!-- Agregar TAG de mesas -->
        <b-card>
            <template v-slot:header>
                    <h6 class="mb-0">Agregar Mesas</h6>
            </template>
            <template >
              <div>
            <b-table
            :busy="isBusy"
            small
            responsive
            :items="listatag3"
            :fields="mesas_fields"
            bordered
            head-variant="dark"
            sticky-header
            >
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            <template slot="acciones" slot-scope="row">
              <b-button variant="ligth" size="sm" class="ml-1" @click="deleteTag(row.item)">
                    <i class="far fa-trash-alt text-danger"></i>
              </b-button> 
              <b-button variant="ligth" size="sm" class="ml-1"  @click="modal(4, row.item)">
                    <i class="far fa-edit text-primary"></i>
              </b-button>  
            </template>
            </b-table>
          </div>
            </template>
            <template v-slot:footer>
              <div class="text-right">
                <b-button variant="success" @click="modal(3)">Agregar Mesa</b-button>
              </div>
          </template>  
        </b-card>
<!-- FIN TAG de mesas -->
      </b-card-group>
    </b-container>
    <b-modal v-model="modalShow"  :title="title">
      <b-row>
        <b-col cols="12" sm="5" md="5" lg="4" xl="10">
          <b-form-input  placeholder="Ingrese Mesa" @keyup.enter="saveTag()" v-model="tag1" ></b-form-input>
        </b-col>
        <b-col cols="12" sm="5" md="5" lg="4" xl="2">
          <b-button v-if="!editandoMesa" :disabled="validar()" variant="success" @click="saveTag()">
            <i class="far fa-save"></i>
          </b-button>
          <b-button v-else :disabled="validar()" variant="info" @click="saveTag()">
            <i class="far fa-save"></i>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
    
          <template >
          <b-table
          :busy="isBusy"
            small
            responsive
            :items="listatag3"
            :fields="mesas_fields"
            bordered
            head-variant="dark"
            sticky-header
            >
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            <template slot="acciones" slot-scope="row">
              <b-button variant="ligth" size="sm" class="ml-1" @click="deleteTag(row.item)">
                    <i class="far fa-trash-alt text-danger"></i>
              </b-button> 
              <b-button variant="ligth" size="sm" class="ml-1"  @click="editarMesa(row.item)">
                    <i class="far fa-edit text-primary"></i>
              </b-button>  
            </template>
            </b-table>
         
          </template>
        </b-col>
      </b-row>  
    </b-modal>
    <vue-snotify></vue-snotify>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "tag",
  data() {
    return {
      perPage: 200,
      currentPage: 1,
      total: "",
      listaTag: [],
      idtag: "",
      tag1: "",
      tag1numero: "",
      tag1adicional: "",
      isBusy: false,
      fields: [
        { key: "tag", label: "Tag", sortable: true },
        // { key: "numeroTag", label: "Nº", sortable: true },
        // { key: "adicional", label: "Adicional", sortable: true },
        { key: "acciones", label: "+ / -", sortable: false }
      ],
      listNumero: ["1", "2"],
      title: "",
      modalShow: false,
      tipo: "",

      listaCategoria:[],
      listaCategoria_fields:[
      // {key:"index",label:"Indice"},
      {Key:"idCategoria",label:"Id"},
      {key:"descripcion",label:"Categoría"},
      {key:"acciones",label:"Acciones"}    
      ],
      mesas_fields:[
      {key:"tag", label:"Mesa"},
      {key:"acciones",label:"Acciones"}   
      ],  
      descripcionCat:'',
      mostraredit:false,
      editCat:'',
      toupdatecatego:{},
      editandoMesa:false,
    };
  },
  mounted() {
    this.listTag();
    this.getCategoria();
  },
  computed: {
    listatag1: function() {
      return this.listaTag.filter(function(item) {
        return item.numeroTag == 1;
      });
    },
    listatag2: function() {
      return this.listaTag.filter(function(item) {
        return item.numeroTag == 2;
      });
    },
    listatag3: function() {
      return this.listaTag.filter(function(item) {
        return item.numeroTag == 3;
        
      });
    }
  },
  methods: {
    listTag: function() {
      this.isBusy = true;
      axios
        .post(process.env.VUE_APP_API_URL + "tag/listar", {
          token: this.$store.getters.userToken,
          current_page: this.currentPage,
          limit: this.perPage,
          order: "desc"
        })
        .then(
          response => (
            (this.listaTag = response.data.data),
            (this.total = response.data.total),
            (this.currentPage = response.data.current_page),
            (this.perPage = response.data.per_page),
            (this.isBusy = false)
          )
        )
        .catch(error => (this.isBusy = false));
    },
    modal: function(tipo, data) {
      if (tipo == 1) {
        this.title = "Nuevo Tag 1";
        this.tag1 = "";
        this.tag1numero = 1;
        this.tag1adicional = "";
      } else if (tipo == 2) {
        this.title = "Nuevo Tag 2";
        this.tag1 = "";
        this.tag1numero = 2;
        this.tag1adicional = "";
      } else if(tipo == 3){
        this.title = "Ingresar Mesa";
        this.tag1 = "";
        this.tag1numero = 3;
        this.tag1adicional = "";
      } else {
        this.title = "Editar Tag";
        this.idtag = data.idTag
        this.tag1 = data.tag;
        this.tag1numero = data.numeroTag;
        this.tag1adicional = data.adicional;
        this.editandoMesa = true;
      }
      this.tipo = tipo;
      this.modalShow = !this.modalShow;
    },
    saveTag: function() {
      let ruta;
      if (this.tipo == 4) {
        ruta = "actualizar";
      } else {
        ruta = "insertar";
      }
      axios
        .post(process.env.VUE_APP_API_URL + "tag/" + ruta, {
          token: this.$store.getters.userToken,
          idtag: this.idtag,
          tag: this.tag1,
          numerotag: this.tag1numero,
          adicional: this.tag1adicional
        })
        .then(
          response => this.$snotify.success(response.data.msg, "Éxito"),
          this.idtag = "",
          (this.tag1 = ""),
          // (this.tag1numero = ""),
          (this.tag1adicional = ""),
          this.editandoMesa = false,
          this.tipo = '',
          this.listTag()
        )
        .catch(function(error) {
          this.$snotify.error(error.response.data.msg, "Error");
        });
    },
    deleteTag: function(value) {
      axios
        .post(process.env.VUE_APP_API_URL + "tag/eliminar", {
          token: this.$store.getters.userToken,
          idtag: value.idTag
        })
        .then(
          response => this.$snotify.success(response.data.msg, "Éxito"),
          this.listTag()
        )
        .catch(function(error) {
          this.$snotify.error(error.response.data.msg, "Error");
        });
    },
/*Categoeria INICIO*/
      getCategoria(){
            this.cargando = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/categoria/listar',{
                 token: this.$store.getters.userToken,
                 order:this.order,
                 limit:this.limite
            })
            .then(response =>(
                this.listaCategoria = response.data,
                this.cargando = false
            ))
            .catch(error => {
                this.cargando = true;
            })
        },
    addCategoria(){
            axios.
            post(process.env.VUE_APP_API_URL + 'productos/categoria/insertar',{
                token: this.$store.getters.userToken,
                descripcion : this.descripcionCat,
                adicional: this.adicionaldoc
            })
            .then(response =>(
                 (this.info = response.data.data),
                 this.$snotify.success(response.data.msg, "Exito"),
                 this.getCategoria(),
                 this.descripcionCat = ''
            ))
            .catch(error =>{
                this.$snotify.warning("Campo vacío o la Categoría ya existe")
            })
        },
      actualizarCategoria(){
                axios
            .post(process.env.VUE_APP_API_URL + 'productos/categoria/actualizar',{
                 token: this.$store.getters.userToken,
                 idcategoria: this.idCategoriaEditar,
                 descripcion : this.editCat,
                 adicional: this.adicionaldoc
                })
            .then(response =>(
                (this.info = response.data.data),
                this.$snotify.success(response.data.msg, "Editado"),
                this.editCat = '',
                this.mostraredit = false,
                this.getCategoria()
            ))
            .catch(error =>{
                 this.$snotify.error(error.response.data.msg, "Error")
            });
        },
      toUpdateCategoria(value, idcategoria){
                this.mostraredit = true;
                this.idCategoriaEditar = idcategoria; //obtengo el idCategoria por parametro
                this.toupdatecatego.descripcion = value;
                this.editCat = value;
        },
      deleteCategoria(value){
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/categoria/eliminar',{
                token: this.$store.getters.userToken,
                idcategoria: value
                })
                .then(response => {                
                    this.$snotify.success(response.data.msg, "Eliminado")
                    this.getCategoria()
                })
                .catch(response =>{
                     this.$snotify.error(error.response.data.msg, "Error")
                })
        },
        validar(){
          if(this.tag1==''){  
            return true
          }else{
            return false
          }
        },
        editarMesa(data){
          this.tipo = 4;
          this.editandoMesa = true;
          this.idtag = data.idTag;
          this.tag1 = data.tag;
          this.tag1numero = data.numeroTag;
          this.tag1adicional = data.adicional;
        }
  /*Categoeria INICIO*/
  }
};
</script>
<style lang="scss" scoped>
fieldset {
  /* background-color: rgba(15, 37, 66, 0.644); */
  border-radius: 4px;
  border: 1px solid rgb(17, 16, 16);
  margin-top: 4px;
  padding: 0 5 0 5;
  width: 100%;
}
legend {
  // background-color: #fff;
  // border: 1px solid rgb(158, 150, 150);
  // border-radius: 4px;
  color: var(--black);
  font-size: 12px;
  font-weight: bold;
  padding: 2px 5px 4px 7px;
  margin-bottom: 4px;
  //margin-left: 40%;
  width: auto;
}
</style>
